/**
 * Hashes all responses in a given cache so that they can be used for comparison later without storing the entire responses in memory.
 *
 * @method getCacheHashMap
 * @param {String} cacheName - the name of the cache to use to build the hash map
 * @returns {Object} an object mapping request urls to hashed strings of their bodies
 */
const getCacheHashMap = async (cacheName) => {
  if (!caches) {
    return;
  }

  const cache = await caches.open(cacheName);
  const requests = await cache.keys();
  const hashMap = {};

  for (let request of requests) {
    // get the blob for the request
    const response = await cache.match(request);
    const blob = await response.blob();

    // convert it to a sha-1 hash
    // sha-1 is insecure, but doesn't need to be secure for this use case
    const blobArrayBuffer = await blob.arrayBuffer();
    const hashArrayBuffer = await window.crypto?.subtle?.digest(
      'sha-1',
      blobArrayBuffer,
    );
    const hash = hashArrayBuffer
      ? new TextDecoder().decode(hashArrayBuffer)
      : '';

    // associate the hash with the request
    hashMap[request.url] = hash;
  }

  return hashMap;
};

export default getCacheHashMap;
